export default __webpack_public_path__ + "static/media/desktop.534ee0e6.png";